import React from 'react';
import ReactSVG from 'react-svg';

import iconFile from 'appSrc/v5/assets/icons/wildlife/previous.svg';

const PreviousIcon = ( props ) => {
    const className = `icon-wrapper ${ props.className || '' }`.trim();

    return (
        <ReactSVG src={ iconFile }
        wrapper='div'
        { ...props }
        className={ className } />
    );
};
PreviousIcon.defaultProps = {
    className: '',
};

export default PreviousIcon;
